/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 26/9/2024
 */

import { useRef } from 'react';         
import Styles from "./FileUploader.module.css"
import { IconButton, Typography } from '@mui/material';
import { AttachFile, Close } from '@mui/icons-material';
import { useState } from 'react';
import { convertFileToBase64 } from '../../Utils/Base64Converter'

export const FileUploader = ({handleFile}) => {

    const [fileName, setFileName] = useState('')
    const hiddenFileInput = useRef(null); 

    const handleClick = event => {
        hiddenFileInput.current.click();   
    };

    const handleChange = async event => {
        // event.preventDefault()
        const file = event.target.files[0];
        const base64 = file ? await convertFileToBase64(file) : null;

        setFileName(file ? file.name : "")
        handleFile(base64, file)
    };

    const onCloseFile = () => {
        setFileName('')
    }

    return (
        <>
        <IconButton className={Styles.attachButton}
            onClick={handleClick}
        >
            <AttachFile className={Styles.attachButtonFile} />
        </IconButton>
        <Typography>{fileName || 'Add file...'}</Typography>
        {fileName && <IconButton className={Styles.closeButton} sx={{padding: 0}} onClick={() => onCloseFile()}>
            <Close className={Styles.close} sx={{width:'1.3rem'}} />
        </IconButton>}
        <input 
            type="file"
            onChange={(e)=>handleChange(e)}
            ref={hiddenFileInput}
            style={{display:'none'}}
        />
        </>
    );
};